import React from "react";
import PropTypes from "prop-types";
import Modal from "../../../../parts/modal-new";

function ConfirmStopTraining(props, { locals }) {
  const {
    athlete,
    activeUser,
    coachOrganizationInformation = undefined,
    query,
  } = locals;
  const referAsClients = Boolean(activeUser.referAsClients);
  return (
    <form
      action={`/actions/user/stop-training/${athlete._id}`}
      method="POST"
      data-noreset
    >
      <Modal
        width="600px"
        title={"Stop Training"}
        className={"stop-training-modal"}
      >
        <div className="body">
          <div className="columns">
            <div className="column" data-col="1/1">
              <b>
                Please acknowledge the following to confirm that you would like
                to stop training this {referAsClients ? "client" : "athlete"}:
              </b>
              {/* init of hidden input that has the organizationCoach value */}
              <div>
                <input
                  id="coachOrganizationInformation"
                  name="coachOrganizationInformation"
                  defaultValue={JSON.stringify(coachOrganizationInformation)}
                  style={{ display: "none" }}
                />
              </div>
              {/* end of hidden input */}
              <div>
                <input
                  type="checkbox"
                  id="stop-training-push-confirm"
                  name="acknowledge"
                  value="push"
                />
                <label htmlFor="stop-training-programs-confirm">
                  I will no longer be able to push programs to this{" "}
                  {referAsClients ? "client" : "athlete"}'s account
                </label>
              </div>
              <div>
                <input
                  type="checkbox"
                  id="stop-training-programs-confirm"
                  name="acknowledge"
                  value="programs"
                />
                <label htmlFor="stop-training-programs-confirm">
                  I will still have access to programs I have created for this
                  {referAsClients ? " client" : " athlete"} unless I choose to
                  delete the programs or remove the
                  {referAsClients ? " client" : " athlete"} from my account
                </label>
              </div>
              <div>
                <input
                  type="checkbox"
                  id="stop-training-list-confirm"
                  name="acknowledge"
                  value="list"
                />
                <label htmlFor="stop-training-list-confirm">
                  I will still have access to this{" "}
                  {referAsClients ? "client" : "athlete"}'s profile unless I
                  choose to remove the {referAsClients ? "client" : "athlete"}{" "}
                  from my account
                </label>
              </div>
              <div>
                <input
                  type="checkbox"
                  id="stop-training-calendar"
                  name="acknowledge"
                  value="list"
                />
                <label htmlFor="stop-training-calendar">
                  I will no longer have access to this{" "}
                  {referAsClients ? "client" : "athlete"}'s calendar and metrics
                </label>
              </div>
              <div>
                <input
                  type="checkbox"
                  id="stop-training-billing"
                  name="acknowledge"
                  value="list"
                />
                <label htmlFor="stop-training-billing">
                  You will not be billed for this{" "}
                  {referAsClients ? "client" : "athlete"} anymore
                </label>
              </div>
            </div>
          </div>
        </div>

        <footer>
          <a
            role="button"
            data-button-type="secondary"
            data-action="cancel"
            href="/actions/refresh?modal="
          >
            Cancel
          </a>
          <button data-button-type="primary" type="submit">
            Stop Training
          </button>
        </footer>
      </Modal>
    </form>
  );
}

ConfirmStopTraining.contextTypes = { locals: PropTypes.object };

export default ConfirmStopTraining;
